exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-container[data-v-6dcfe48c]{position:absolute;left:0;top:2.75rem;width:100%;height:calc(100vh - 2.75rem);background:#fff;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:0 1.25rem}.mb-container .empty[data-v-6dcfe48c]{width:14.22rem;height:7.5rem;margin-bottom:1.25rem}.mb-container p[data-v-6dcfe48c]{font-size:.88rem;font-weight:400;color:#999;line-height:1.41rem;letter-spacing:.06rem}.mb-container .qrcode[data-v-6dcfe48c]{width:6.25rem;height:6.25rem;margin-top:1.25rem}", ""]);

// exports
